import { Button, Input, Card, CardHeader, CardBody } from '@nextui-org/react';
import React, { useState, useEffect } from 'react';
import { editProfileValidate } from '../../utils/Validation/editProfileConstraint';
import { useSelector } from 'react-redux';
import { decryptData } from '../../utils/encryptData';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

function EditProfile() {
  const [errors, setErrors] = useState({});
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const navigate = useNavigate();

  const { em, username, mobile } = useSelector((state) => state.auth);

  const email = decryptData(em);
  const mobileNumber = decryptData(mobile);

  useEffect(() => {
    setName(username);
    setPhoneNumber(mobileNumber);
  }, [username, mobileNumber]);

  // Handle form submission
  const submitForm = async () => {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('fullName', name);
    formData.append('phoneNumber', phoneNumber);

    // Validate form
    const validationErrors = await editProfileValidate({ name, phoneNumber });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      formData.forEach((Item) => console.log(Item));
      const res = await PrivateAxiosInstance.put(
        URLs.UPDATE_PROFILE,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      if (res.status === 200) {
        message.success('Profile updated successfully');
        navigate('/');
      }
    } catch (err) {
      console.error('Profile update error: ', err);
      message.error('Profile update error');
    }
  };

  return (
    <div className="mt-[70px] md:mt-[100px] flex flex-col gap-4 items-center justify-center">
      <Card className="w-full max-w-3xl p-3">
        <CardHeader>
          <h3 className="text-xl font-bold font-poppins">Edit Profile</h3>
        </CardHeader>
        <CardBody className="gap-6">
          {/* Email field is non-editable */}
          <Input
            label="Email"
            labelPlacement="outside"
            value={email}
            className="font-poppins cursor-not-allowed"
            isReadOnly
            isDisabled
          />

          {/* Name field is editable */}
          <Input
            label="Name"
            labelPlacement="outside"
            value={name}
            onChange={(e) => setName(e.target.value)}
            isInvalid={Boolean(errors?.name)}
            errorMessage={errors?.name || ''}
            className="font-poppins"
          />

          {/* Phone Number field is editable */}
          <Input
            label="Phone Number"
            labelPlacement="outside"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            isInvalid={Boolean(errors?.phoneNumber)}
            errorMessage={errors?.phoneNumber || ''}
            className="font-poppins"
          />

          <div className="flex justify-end mt-3">
            <Button
              onClick={() => navigate('/')}
              className="bg-red-500 font-poppins text-black font-medium text-md mr-3"
            >
              Cancel
            </Button>

            <Button
              onClick={submitForm}
              className="bg-btn-color font-poppins text-black font-medium text-md"
            >
              Submit
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default EditProfile;
